import React from 'react';
import { Phone, Calendar } from 'lucide-react';

const MobileCallBar = ({ onBookClick }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#0A0A0A] border-t border-[#2A2A2A] p-3 safe-area-inset-bottom">
      <div className="flex gap-3">
        {/* Call Button */}
        <a
          href="tel:+393773781602"
          className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold py-3 px-4 transition-all active:scale-95"
          data-testid="mobile-call-btn"
        >
          <Phone className="w-5 h-5" />
          <span>Chiama</span>
        </a>
        
        {/* Book Button */}
        <button
          onClick={onBookClick}
          className="flex-1 flex items-center justify-center gap-2 bg-[#FFCC00] text-[#0A0A0A] font-bold py-3 px-4 transition-all active:scale-95"
          data-testid="mobile-book-btn"
        >
          <Calendar className="w-5 h-5" />
          <span>Prenota</span>
        </button>
      </div>
    </div>
  );
};

export default MobileCallBar;
